import{ useEffect, useState } from 'react';
import { useSelector } from 'react-redux';


export default function Stats() {
  const Numberapp = useSelector((state) => state.app.appNumber);
  const token = useSelector((state) => state.user.token);
    const apiPrefix = process.env.REACT_APP_API_PREFIX;
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
      const fetchUsers = async () => {
        try {
          const response = await fetch(apiPrefix + 'users', {
            method: 'GET', 
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
              'X-App-Number': Numberapp // Envoyer appNumber via l'en-tête
            },
          });
  
          if (!response.ok) {
            throw new Error('Erreur lors de la récupération des utilisateurs');
          }
  
          const data = await response.json();
          setUsers(data);
          setIsLoading(false);
        } catch (error) {
          console.error("Erreur lors de la récupération des utilisateurs :", error);
          setError(error.message);
          setIsLoading(false);
          
        }
      };
  
      fetchUsers();
    }, [apiPrefix, Numberapp, token]);
      
const date = new Date();
const currentMonth = date.getMonth();
const currentYear = date.getFullYear();



const userConnectedThisMonth = users.filter((user) => {
    const lastActive = new Date(user.lastactive);
    return lastActive.getMonth() === currentMonth && lastActive.getFullYear() === currentYear;
})


const userCreatedThisMonth = users.filter((user) => {
    const creationDate = new Date(user.creationDate);
    return creationDate.getMonth() === currentMonth && creationDate.getFullYear() === currentYear;
})

const createdActiveThisMonth = users.filter((user) => {
    const creationDate = new Date(user.creationDate);
    const lastActive = new Date(user.lastactive);
    return creationDate.getMonth() === currentMonth && creationDate.getFullYear() === currentYear && lastActive.getMonth() === currentMonth && lastActive.getFullYear() === currentYear;
})





      if (isLoading) {
        return (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-theme-accent"></div>
            <span className="ml-3 text-gray-600">Chargement des statistiques...</span>
          </div>
        );
      }

      if (error) {
        return (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
            <i className="fas fa-exclamation-triangle mr-2"></i>
            {error}
          </div>
        );
      }

      return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-gradient-to-br from-theme-primary/10 to-theme-primary/20 p-6 rounded-lg border border-theme-primary/30">
            <div className="flex items-center">
              <div className="bg-theme-primary text-white p-3 rounded-lg mr-4">
                <i className="fas fa-user-plus text-xl"></i>
              </div>
              <div>
                <p className="text-sm text-theme-primary font-medium">Inscriptions ce mois</p>
                <p className="text-2xl font-bold text-theme-primary-active">{userCreatedThisMonth.length}</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-lg border border-green-200">
            <div className="flex items-center">
              <div className="bg-green-500 text-white p-3 rounded-lg mr-4">
                <i className="fas fa-user-check text-xl"></i>
              </div>
              <div>
                <p className="text-sm text-green-600 font-medium">Inscrits & Actifs ce mois</p>
                <p className="text-2xl font-bold text-green-800">{createdActiveThisMonth.length}</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-lg border border-purple-200">
            <div className="flex items-center">
              <div className="bg-purple-500 text-white p-3 rounded-lg mr-4">
                <i className="fas fa-sign-in-alt text-xl"></i>
              </div>
              <div>
                <p className="text-sm text-purple-600 font-medium">Connexions ce mois</p>
                <p className="text-2xl font-bold text-purple-800">{userConnectedThisMonth.length}</p>
              </div>
            </div>
          </div>
        </div>
      );
}